/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Metric_Job_CountInputs */

const en_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Count`)
};

const fr_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d'emplois`)
};

const de_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Arbeitsplätze`)
};

const it_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteggio dei lavori`)
};

const ru_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество рабочих мест`)
};

const es_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuento de trabajos`)
};

const zh_cn2_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作数量`)
};

const ja_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブ数`)
};

const hi_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरियों की संख्या`)
};

const pt_pt2_usage_metric_job_count = /** @type {(inputs: Usage_Metric_Job_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contagem de empregos`)
};

/**
* | output |
* | --- |
* | "Job Count" |
*
* @param {Usage_Metric_Job_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_metric_job_count = /** @type {((inputs?: Usage_Metric_Job_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Metric_Job_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_metric_job_count(inputs)
	if (locale === "de") return de_usage_metric_job_count(inputs)
	if (locale === "it") return it_usage_metric_job_count(inputs)
	if (locale === "ru") return ru_usage_metric_job_count(inputs)
	if (locale === "es") return es_usage_metric_job_count(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_metric_job_count(inputs)
	if (locale === "ja") return ja_usage_metric_job_count(inputs)
	if (locale === "hi") return hi_usage_metric_job_count(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_metric_job_count(inputs)
	return en_usage_metric_job_count(inputs)
});